import { createSelector } from '@ngrx/store';
import { selectUploads } from './upload.reducer';

export const selectUploadById = (id: string) =>
  createSelector(selectUploads, (uploads) => uploads[id] ?? null);

export const selectIsUploading = (id: string) =>
  createSelector(selectUploadById(id), (upload) =>
    upload ? upload.status === 'in-progress' || upload.status === 'pending' : false
  );
